module.exports = __webpack_public_path__ + "static/media/RGM_Hubble_logo.3f4e4d1b.gif";